import { render, staticRenderFns } from "./ModalCadastroCallback.vue?vue&type=template&id=a3fae294&scoped=true&"
import script from "./ModalCadastroCallback.vue?vue&type=script&lang=js&"
export * from "./ModalCadastroCallback.vue?vue&type=script&lang=js&"
import style0 from "./ModalCadastroCallback.vue?vue&type=style&index=0&id=a3fae294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fae294",
  null
  
)

export default component.exports